<div class="modal-container" *ngIf="showModal">
  <div class="modal-content">
    <ng-template [ngTemplateOutlet]="template"></ng-template>
  </div>
</div>
